
import { Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './contexts/AuthContext'
import { StatsProvider } from './contexts/StatsContext'
import Layout from './components/Layout'
import Login from './pages/Login'
import Register from './pages/Register'
import Dashboard from './pages/Dashboard'
import Trades from './pages/Trades'
import Analytics from './pages/Analytics'
import AIInsights from './pages/AIInsightsNew'
import TradingCalendar from './pages/TradingCalendar'
import PnL from './pages/PnL'
import Social from './pages/Social'
import Settings from './pages/Settings'
import LoadingSpinner from './components/LoadingSpinner'

function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="xl" />
          <p className="mt-4 text-gray-600">Loading your trading journal...</p>
        </div>
      </div>
    )
  }

  return (
    <Routes>
      {/* Public routes */}
      <Route 
        path="/login" 
        element={!user ? <Login /> : <Navigate to="/dashboard" replace />} 
      />
      <Route 
        path="/register" 
        element={!user ? <Register /> : <Navigate to="/dashboard" replace />} 
      />
      
      {/* Protected routes */}
      {user ? (
        <Route path="/" element={<StatsProvider><Layout /></StatsProvider>}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="trades" element={<Trades />} />
          <Route path="analytics" element={<Analytics />} />
          <Route path="calendar" element={<TradingCalendar />} />
          <Route path="ai-insights" element={<AIInsights />} />
          <Route path="pnl" element={<PnL />} />
          <Route path="social" element={<Social />} />
          <Route path="settings" element={<Settings />} />
        </Route>
      ) : (
        // Redirect unauthenticated users to login
        <Route path="*" element={<Navigate to="/login" replace />} />
      )}
    </Routes>
  )
}

export default App